<template>
  <div class="content">
    <div class="prompt" v-if="(!isEdit && shouldShowPrompt())"><i class="el-icon-warning" style="font-size: 16px; margin-right: 4px"></i>{{ $t('message.completeCompanyInfo') }}</div>
    <div class="wrap">
      <div class="page-header">
        <h1>{{ $t('companyInfo.companyInfo') }}</h1>
        <p class="desc" v-if="$i18n.locale !== 'zh'">{{ $t('companyInfo.companyInfoTitle') }}</p>
      </div>
      <div class="header-actions" v-if="!isEdit">
        <span @click="handleEdit"><i class="el-icon-edit-outline"></i>{{ $t('companyInfo.edit') }}</span>
      </div>
      <div class="companyInfo">
        <el-form :model="formData" :rules="isEdit ? formRules : undefined" ref="companyInfoForm" class="ms-content" size="large" style="width:500px">
          <el-form-item :label="$t('companyInfo.companyName')" prop="companyName">
            <el-input
              v-model="formData.companyName"
              :readonly="isReadonly"
              :placeholder="$t('companyInfo.companyNamePlaceholder')"
            ></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('companyInfo.brandNameEN')" prop="brandNameEN">
                <el-input
                  v-model.trim="formData.brandNameEN"
                  :readonly="isReadonly"
                  :placeholder="$t('companyInfo.brandNameEN')"
                ></el-input>
              </el-form-item>
            </el-col>
            
            <el-col :span="12">
              <el-form-item :label="$t('companyInfo.brandNameCN')" prop="brandNameCN">
                <el-input
                  v-model.trim="formData.brandNameCN"
                  :readonly="isReadonly"
                  :placeholder="$t('companyInfo.brandNameCN')"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('companyInfo.country')" prop="country">
                <el-select 
                  v-model="formData.country" 
                  :disabled="!isEdit"
                  clearable
                  filterable
                  :placeholder="$t('companyInfo.country')"
                >
                  <el-option
                    v-for="item in countryList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            
            <el-col :span="12">
              <el-form-item :label="$t('companyInfo.industry')" prop="industry">
                <el-select 
                  v-model="formData.industry" 
                  :disabled="!isEdit"
                  clearable
                  filterable
                  :placeholder="$t('companyInfo.industry')"
                >
                  <el-option
                    v-for="item in industryList"
                    :key="item.value"
                    :label="$i18n.locale === 'zh' ? item.labelZh : item.labelEn"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item :label="$t('companyInfo.websiteURL')" prop="websiteURL">
            <el-input
              v-model.trim="formData.websiteURL"
              :readonly="isReadonly"
              :placeholder="$t('companyInfo.urlExplame')"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="isEdit">
            <div class="form-actions">
              <div class="left-actions">
                <el-button @click="handleReset">{{$t('companyInfo.reset')}}</el-button>
              </div>
              <div class="right-actions">
                <el-button @click="handleCancel">{{$t('companyInfo.cancel')}}</el-button>
                <el-button type="primary" @click="dialogVisible = true">{{$t('companyInfo.save')}}</el-button>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <el-dialog
        :title="$t('message.confirmCompanyInfo')"
        class="comfirmDialog"
        :visible.sync="dialogVisible"
        width="30%"
      >
        <div>
          <p>
            {{ this.$t('message.mofifyPrompt') }}
          </p>
        </div>
        
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">{{this.$t('message.cancel')}}</el-button>
          <el-button type="primary" @click="submitCompanyInfo('companyInfoForm')">{{this.$t('message.confirmModify')}}</el-button>
        </div>
      </el-dialog>
    </div>
    
  </div>
</template>

<script>
import util from '@/utils/util'

const formDataDefault = {
  companyName: "",
  brandNameCN: "",
  brandNameEN: "",
  country: "",
  industry: "",
  websiteURL: ""
};
export default {
  name: "CompanyInfo",
  data() {
    return {
      dialogVisible: false,
      isReadonly: true,
      isEdit: false,
      formData: Object.assign({}, formDataDefault),
      countryList: [],
      industryList: [
        { value: 'Gaming', labelZh: '游戏', labelEn: 'Gaming' },
        { value: 'Tools / Utilities', labelZh: '工具类', labelEn: 'Tools / Utilities' },
        { value: 'Entertainment', labelZh: '娱乐类', labelEn: 'Entertainment' },
        { value: 'Social', labelZh: '社交', labelEn: 'Social' },
        { value: 'Education', labelZh: '教育', labelEn: 'Education' },
        { value: 'Lifestyle', labelZh: '生活方式', labelEn: 'Lifestyle' },
        { value: 'Productivity', labelZh: '效率类', labelEn: 'Productivity' },
        { value: 'Music / Audio', labelZh: '音乐/音频', labelEn: 'Music / Audio' },
        { value: 'Finance', labelZh: '金融/投资', labelEn: 'Finance' },
        { value: 'Health / Fitness', labelZh: '健康类', labelEn: 'Health / Fitness' },
        { value: 'Shopping / E-commerce', labelZh: '电商', labelEn: 'Shopping / E-commerce' },
        { value: 'Travel', labelZh: '旅游', labelEn: 'Travel' },
        { value: 'News / Media', labelZh: '新闻/资讯类', labelEn: 'News / Media' },
        { value: 'Kids / Family', labelZh: '儿童', labelEn: 'Kids / Family' },
        { value: 'Photography', labelZh: '摄影类', labelEn: 'Photography' },
        { value: 'Business', labelZh: '商务类', labelEn: 'Business' }
      ]
    };
  },
  computed: {
    formRules() {
      return {
        companyName: [
          { required: true, message: this.$t('companyInfo.companyNameCheck'), trigger: "blur" },
          { 
            validator: (rule, value, callback) => {
              const val = value.trim() || '';
              if (!val) {
                callback();
                return;
              }

              if (/^\d/.test(val) || /\d$/.test(val)) {
                callback(new Error(this.$t('companyInfo.companyNameStartEndCheck')));
                return;
              }
              const utf8Length = new Blob([val]).size;
              if (utf8Length < 2 || utf8Length > 120) {
                callback(new Error(this.$t('companyInfo.companyNameLengthCheck')));
                return;
              }

              const invalidCharReg = /[@#$%&*!?^~'"\\/|{}[\]<>]|[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}]/u;
              if (invalidCharReg.test(val)) {
                callback(new Error(this.$t('companyInfo.companyNameSpecialCharCheck')));
                return;
              }
              callback();
            },
            trigger: ["blur"] 
          }
        ],  
        brandNameEN: [
          { required: true, message: this.$t('companyInfo.brandNameENCheck'), trigger: "blur" },
          { pattern: /^[a-zA-Z]+$/, message: this.$t('companyInfo.brandNameENFormatCheck'), trigger: "blur"},
          { 
            validator: (rule, value, callback) => {
              if (value && value === this.formData.companyName) {
                callback(new Error(this.$t('companyInfo.brandNameENUniqueCheck')))
              } else {
                callback()
              }
            },
            trigger: "blur"
          }
        ],  
        brandNameCN: [
          { pattern: /^[\u4e00-\u9fa5a-zA-Z0-9\s]*$/, message: this.$t('companyInfo.brandNameCNFormatCheck'), trigger: "blur"},
          { 
            validator: (rule, value, callback) => {
              if (!value || value.trim() === '') {
                callback()
                return;
              }
              
              if (!/[\u4e00-\u9fa5]/.test(value)) {
                callback(new Error(this.$t('companyInfo.brandNameCNChineseCheck')));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],    
        country: [
          { required: true, message: this.$t('companyInfo.countryCheck'), trigger: "change" }
        ],       
        industry: [
          { required: true, message: this.$t('companyInfo.industryCheck'), trigger: "change" },
        ], 
        websiteURL: [
          { 
            pattern: /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/,
            message: this.$t('companyInfo.websiteFormatCheck'),
            trigger: "blur"
          }
        ]
      }
    }
  },
  created() {
    this.getCountryList()
    this.getCompanyInfo()
    const userObj = JSON.parse(util.getCookie('user'))
    if(userObj.verify_code == 0) {
      if(!userObj.old_user) {
        this.isReadonly = false
        this.isEdit = true
      }
    }
  },
  methods: {
    getCountryList() {
      this.__getData('getCountryList',null, res => {    
        this.countryList = res.country_info
      })
    },
    getCompanyInfo() {
      let params = {
        email: JSON.parse(util.getCookie("user")).email
      }
      this.__getData('getCompanyInfo', params, res => {
        this.formData.companyName = res.company_name
        this.formData.brandNameCN =  res.brand_name_cn
        this.formData.brandNameEN =  res.brand_name_en
        this.formData.country =  res.country
        this.formData.industry =  res.industry
        this.formData.websiteURL =  res.website_url

      })
    },
    // 重置表单
    handleReset() {
      this.getCompanyInfo()
    },
    handleCancel() {
      this.isEdit = false
      this.isReadonly = true
      this.getCompanyInfo()
    },
    // 提交表单
    submitCompanyInfo(companyInfoForm) {
      this.$refs[companyInfoForm].validate((valid, data) => {
        if (valid) {
          const params = {
            email: JSON.parse(util.getCookie("user")).email,
            company_name: this.formData.companyName.trim(),
            brand_name_en: this.formData.brandNameEN,
            brand_name_cn: this.formData.brandNameCN,
            country: this.formData.country,
            industry: this.formData.industry,
            website_url: this.formData.websiteURL
          }
          this.__putData("updateCompanyInfo", params, res => {
            if (res.code == 1) {
              this.$message.error(res.msg)
            } else {
              this.$message.success(this.$t('message.successSava'))
              const userObj = JSON.parse(util.getCookie('user'))
              userObj.verify_code = res.verify_code
              util.setCookie('user', JSON.stringify(userObj), 7)
              this.formData = Object.assign({}, formDataDefault)
              this.$eventBus.$emit('companyUpdated')
              this.isEdit = false
              this.isReadonly = true
              this.dialogVisible = false
              this.getCompanyInfo() 
            }
          }, errmsg => {
            this.$message.error(errmsg)
          })
        } else {
          this.$message.error(this.$t('message.completeForm'))
        }
      })
    },
    handleEdit() {
      this.isEdit = true
      this.isReadonly = false
    },
    shouldShowPrompt() {
        const userStr = util.getCookie("user")
        if (!userStr) return false
        
        const user = JSON.parse(userStr)
        return user.verify_code === 0
    },
  }
};
</script>

<style scoped>
.content {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
  background: #f5f7fa;
}

.wrap {
  width: 100%;
  max-width: 500px; 
  background-color: #ffffff; 
  border: 1px solid #e6e6e6; 
  border-radius: 8px; 
  padding: 30px; 
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05); 
  position: relative;
}
.header-actions {
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
  color: #3361FF;
}
.page-header {
  margin-bottom: 30px;
  text-align: center;
  width: 100%;
}

.page-header h1 {
  margin: 0 0 8px 0;
  font-size: 24px;
  font-weight: 600;
  color: #303133;
}

.desc {
  margin: 0;
  font-size: 14px;
  color: #909399;
}

.companyInfo {
  width: 100%;
}

.form-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
}

.right-actions {
  display: flex;
  gap: 12px;
}
.prompt {
   margin-bottom: 20px;
  padding: 12px 16px;  
  font-size: 14px;    
  text-align: center;
  color: #e6a23c;
  background-color: #fdf6ec;  
  border: 1px solid #f5dab1;
  border-radius: 4px;  
  display: flex;      
  align-items: center;
  justify-content: center;
  gap: 8px;   
}
</style>